import { IconAlertTriangleFilled } from '@tabler/icons-react';
import { Button, Stack, Box, Title, Flex, Text, Anchor } from '@mantine/core';

const ConfigurationAlertView = () => (
  <Stack gap="md">
    <Flex gap="xs" align="center">
      <IconAlertTriangleFilled color="var(--mantine-color-orange-3)" size="2rem" />
      <Title order={3}>Fooda reporting configuration alert</Title>
    </Flex>
    <Text>
      Your browser settings or extensions are blocking Fooda’s reporting tools. Please use the
      button below to troubleshoot if you wish to see reporting.
    </Text>
    <Text>
      If you are still experiencing issues after following the troubleshooting steps, please{' '}
      <Anchor
        href="https://foodacustomerhelp.atlassian.net/servicedesk/customer/portal/3"
        target="_blank"
        rel="noreferrer"
      >
        contact the Fooda support team
      </Anchor>
    </Text>
    <Box mx={{ base: 'auto', sm: '0' }}>
      <Button
        component="a"
        href="https://foodajira.atlassian.net/wiki/external/ZmEyYTg0NDNiMDhhNGUwMTg4ZGZmMGE1YjA4YTIwNDQ"
        target="_blank"
        rel="noreferrer"
      >
        Click here to troubleshoot
      </Button>
    </Box>
  </Stack>
);

export default ConfigurationAlertView;
